import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const faqs = [
  {
    question: "How does StockNow track inventory levels?",
    answer:
      "StockNow uses real-time inventory tracking powered by AI. You can monitor stock levels across multiple locations, set automatic reorder points, and receive alerts when products run low or go out of stock.",
  },
  {
    question: "Can StockNow notify customers when products are back in stock?",
    answer:
      "Yes! When a product is out of stock, customers can join a waitlist. StockNow automatically notifies them via email or SMS as soon as the item becomes available again, helping you recover lost sales.",
  },
  {
    question: "What kind of analytics does StockNow provide?",
    answer:
      "StockNow offers comprehensive analytics including sales trends, demand forecasting, best-selling products, customer waitlist reports, and inventory turnover rates to help you make data-driven decisions.",
  },
  {
    question: "Is StockNow suitable for small businesses?",
    answer:
      "Absolutely! StockNow is designed for businesses of all sizes. Whether you have a single store or multiple locations, our scalable solution adapts to your needs with flexible pricing plans.",
  },
  {
    question: "How do I integrate StockNow with my existing systems?",
    answer:
      "StockNow provides easy integration with popular e-commerce platforms, POS systems, and accounting software. Our API documentation and support team make setup quick and hassle-free.",
  },
  {
    question: "Can multiple team members access the dashboard?",
    answer:
      "Yes, StockNow supports multiple user accounts with role-based permissions. You can assign different access levels for managers, staff, and administrators to ensure secure collaboration.",
  },
  {
    question: "Does StockNow support multiple warehouse locations?",
    answer:
      "Yes, you can manage inventory across multiple warehouses or retail locations from a single dashboard. Transfer stock between locations and track availability at each site in real-time.",
  }
];

const FaqSection = () => {
    const { t } = useTranslation();
    const [openIndex, setOpenIndex] = useState(null);
  
    const toggle = (index) => {
      setOpenIndex(openIndex === index ? null : index);
    };
  
    return (
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="text-5xl font-bold">{t('faq.title')}</h2>
          </div>
  
          <div className="max-w-6xl mx-auto">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded mb-1 shadow-sm"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full text-left px-6 py-4 flex justify-between items-center bg-yellow-500 hover:bg-yellow-600 transition"
                >
                  <span className="text-lg font-medium text-white">
                    {faq.question}
                  </span>
                  {openIndex === index ? (
                    <FaChevronUp className="text-white" />
                  ) : (
                    <FaChevronDown className="text-white" />
                  )}
                </button>
  
                <AnimatePresence initial={false}>
                  {openIndex === index && (
                    <motion.div
                      key="content"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                      className="overflow-hidden"
                    >
                      <div className="px-6 py-4 text-gray-700 bg-white text-start opacity-90">
                        {faq.answer}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };
  

export default FaqSection;
